export let PusherEventName = /*#__PURE__*/function (PusherEventName) {
  PusherEventName["InvoiceXeroIntegrationStatusUpdated"] = "InvoiceXeroIntegrationStatusUpdated";
  PusherEventName["InvoiceQboIntegrationStatusUpdated"] = "InvoiceQboIntegrationStatusUpdated";
  PusherEventName["InvoiceRefundFailed"] = "InvoiceRefundFailed";
  PusherEventName["InvoiceUnvoided"] = "InvoiceUnvoided";
  PusherEventName["InvoiceUnmarkedAsPaidExternally"] = "InvoiceUnmarkedAsPaidExternally";
  PusherEventName["PayoutXeroIntegrationStatusUpdated"] = "PayoutXeroIntegrationStatusUpdated";
  PusherEventName["PayoutQboIntegrationStatusUpdated"] = "PayoutQboIntegrationStatusUpdated";
  PusherEventName["RelationshipCreatedFromScheduledDraft"] = "RelationshipCreatedFromScheduledDraft";
  return PusherEventName;
}({});